import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const BasicsItem = styled.button<{ $enabled?: boolean }>`
  margin: 0;
  display: flex;
  flex-direction: row;
  border: 1px solid transparent;
  background: none;
  outline: none;
  border-radius: 10px;
  gap: 0.8rem;
  padding: 0.4rem 0.8rem;
  width: 100%;
  position: relative;

  :hover {
    border: 1px solid #3a3a3c;
    background: #2c2c2e;

    > p {
      color: ${vars.colors.grey30};
    }

    path {
      color: ${vars.colors.grey30};
      stroke: ${vars.colors.grey30};
    }
  }

  ${(props) =>
    !props.$enabled &&
    css`
      cursor: not-allowed;
    `}
`;

export const BasicsLabel = styled(Paragraph)<{ $isFilled?: boolean }>`
  flex: 1;
  text-align: start;
  color: ${vars.colors.grey70};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) =>
    props.$isFilled &&
    css`
      color: ${vars.colors.grey30};
    `};
`;

export const BasicsIcon = styled.svg<{ $isFilled?: boolean }>`
  flex-basis: 2rem;
  height: 2rem;

  path {
    color: ${vars.colors.grey70};
    stroke: ${vars.colors.grey70};
  }

  ${(props) =>
    props.$isFilled &&
    css`
      path {
        color: ${vars.colors.grey30};
        stroke: ${vars.colors.grey30};
      }
    `}
`;

export const BasicsImage = styled.img`
  width: 2rem;
  height: 2rem;
`;
